<core-layout-auth [config]="config">
    <form [formGroup]="form" (ngSubmit)="onFormSubmit()" class="c-entry-group">
        <label class="c-entry-item">
            <span class="c-entry-input">
                <span class="c-entry-input__addon icon-email-thin"></span>
                <input 
                    type="text" 
                    id="email" 
                    formControlName="email"
                    [placeholder]="'forgotPassword.emailPlaceholder' | translate"
                    [class.error]="form.get('email')?.touched && form.get('email')?.invalid">
            </span>

            @if (form.get('email')?.touched && form.get('email')?.invalid) {
                <span class="c-entry-error">
                    {{ 'forgotPassword.emailRequired' | translate }}
                </span>
            }
        </label>
        

        <button 
            type="submit" 
            class="c-login__submit c-btn" 
            [class.is-loading]="loading()"
            [disabled]="loading() || form.invalid">
            {{ 'forgotPassword.btnForgot' | translate }}
        </button>
    </form>

  <div class="u-align-center">
    <a 
      [routerLink]="['/auth/login']" 
      class="c-link--underlined c-link--primary">
      {{ 'forgotPassword.btnBack' | translate }}
    </a>
  </div>
</core-layout-auth>